import { useQuery } from "react-query";
import { CasProfileApi } from "@jti/rest-api";
import { INFINITY_CACHE, REACT_QUERY_KEYS } from "../constants/reactQueryConstants";
export const useGetProfile = () => {
    const casProfileApi = CasProfileApi.init();
    return useQuery(REACT_QUERY_KEYS.profile, () => casProfileApi.getProfile(), {
        ...INFINITY_CACHE,
    });
};
//# sourceMappingURL=useGetProfile.js.map